import React from "react";

export interface IconProps {
  width?: number;
  height?: number;
  color?: string;
}

export default function RemoveIcon(props: IconProps): JSX.Element {
  const { width, height, color } = props;
  return (
    <svg
      width={width || 20.922}
      height={height || 19.5}
      viewBox="0 0 20.922 19.5"
    >
      <g data-name="Remove Tag" opacity={0.8}>
        <g data-name="Group 115">
          <path
            data-name="Path 1056"
            d="M287.51 209.26a1.688 1.688 0 011.688-1.688h7.176a1.94 1.94 0 011.193.495l7.449 7.449a1.687 1.687 0 010 2.386l-7.176 7.176a1.688 1.688 0 01-2.387 0L288 217.629a1.942 1.942 0 01-.494-1.193zm3.25 3.25a1.688 1.688 0 101.688-1.688 1.687 1.687 0 00-1.688 1.688z"
            fill="none"
            stroke={color || "#bbb"}
            strokeWidth={1.5}
            transform="translate(-286.76 -206.822)"
          />
        </g>
        <g data-name="Group 117" transform="translate(-286.76 -206.822)">
          <circle
            data-name="Ellipse 90"
            cx={5.204}
            cy={5.204}
            r={5.204}
            transform="translate(296.874 211.207)"
            fill="#fff"
          />
          <g data-name="Group 116">
            <path
              data-name="Path 1057"
              d="M306.071 219.978a5.5 5.5 0 110-7.778 5.5 5.5 0 010 7.778zm-1.192-2.07a.267.267 0 000-.376l-1.443-1.443 1.443-1.442a.269.269 0 000-.377l-.878-.878a.268.268 0 00-.377 0l-1.442 1.443-1.443-1.443a.266.266 0 00-.376 0l-.879.878a.269.269 0 000 .377l1.443 1.442-1.443 1.443a.267.267 0 000 .376l.879.879a.267.267 0 00.376 0l1.443-1.443 1.442 1.443a.269.269 0 00.377 0z"
              fill={color || "#bbb"}
            />
          </g>
        </g>
      </g>
    </svg>
  );
}
